module.exports = __webpack_public_path__ + "static/media/no.bd2b5d24.png";